// extracted by mini-css-extract-plugin
export var banner = "_gj-0";
export var closeButton = "_gj-2";
export var greenCheckmark = "_gj-3";
export var hereLink = "_gj-4";
export var titleIcon = "_gj-1";